export function createWalletProvidersRegistry() {
    let entries = [];
    const listeners = new Set();
    const innerUnsubs = new Map();
    const notify = () => {
        for (const listener of listeners)
            listener();
    };
    return {
        getEntries() {
            return entries;
        },
        getStoreById(id) {
            return entries.find(e => e.id === id)?.store;
        },
        /** Convenience for non-React peers that need a peer provider's current snapshot. */
        getById(id) {
            return this.getStoreById(id)?.getState();
        },
        setEntries(next) {
            if (next === entries)
                return;
            const nextById = new Map(next.map(e => [e.id, e.store]));
            // Tear down inner subs for ids that are gone OR whose store changed.
            for (const [id, unsub] of innerUnsubs) {
                const nextStore = nextById.get(id);
                const prevStore = entries.find(e => e.id === id)?.store;
                if (!nextStore || nextStore !== prevStore) {
                    unsub();
                    innerUnsubs.delete(id);
                }
            }
            // Subscribe newly added stores.
            for (const e of next) {
                if (!innerUnsubs.has(e.id)) {
                    innerUnsubs.set(e.id, e.store.subscribe(notify));
                }
            }
            entries = next;
            notify();
        },
        subscribe(listener) {
            listeners.add(listener);
            return () => { listeners.delete(listener); };
        },
    };
}
